export default __webpack_public_path__ + "assets/685378d2a2436f78a4664e9068aa759f.jpeg";